import { render } from "./RcsTestRecipientPanel.vue?vue&type=template&id=34c489e7&scoped=true"
import script from "./RcsTestRecipientPanel.vue?vue&type=script&lang=ts"
export * from "./RcsTestRecipientPanel.vue?vue&type=script&lang=ts"

import "./RcsTestRecipientPanel.vue?vue&type=style&index=0&id=34c489e7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-34c489e7"

export default script